import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PortsListTable from './Table';
import { getPorts } from 'actions/regions/ports';

class PortsPage extends React.Component {

    UNSAFE_componentWillMount() {
        const { page, query, onlyChanged, sort } = this.props;
        this.props.getPorts({ page, query, onlyChanged, sort  });
    }

    render() {
        return (
            <div id='ports' className='table-page'>
                    <div className='container'>
                        <h2>
                           Ports
                        </h2>

                        <PortsListTable />
                    </div>
            </div>
        );
    }
}

PortsPage.propTypes = {
    isLogged: PropTypes.bool,
    getPorts: PropTypes.func,
};

PortsPage.defaultProps = {
    isLogged: false,
    getPorts: () => {
        console.error(`PortsPage didn't find getPorts function`)
    },
};

export default connect(
    ({ user: { isLogged }, ports: { page, query, onlyChanged, sort } }) => {
        return {
            isLogged,
            page,
            query,
            onlyChanged,
            sort,
        };
    },
    dispatch => bindActionCreators({
            getPorts,
    },
    dispatch),
)(PortsPage);



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Page.jsx